<template>
  <div v-if="visible" class="round-stats-overlay round-stats-backdrop" @click.self="$emit('close')">
    <div class="round-stats-panel round-stats-modal">
      <div class="round-stats-header">
        <div class="round-stats-heading">
          <p class="round-stats-eyebrow">{{ tOr('menu.statistics', 'Statistics') }}</p>
          <h3>{{ modalTitle }}</h3>
          <p class="round-stats-subtitle">{{ modalSubtitle }}</p>
        </div>
        <button type="button" class="round-stats-close" @click="$emit('close')">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="round-stats-body">
        <RoundStatisticsContent :loading="loading" :stats="stats" :error="error" />
      </div>
    </div>
  </div>
</template>

<script>
import RoundStatisticsContent from '@/components/competitions/RoundStatisticsContent.vue';

export default {
  name: 'RoundStatisticsModal',
  components: { RoundStatisticsContent },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    stats: {
      type: Object,
      default: null,
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    roundContext() {
      return this.stats?.round_context || {};
    },
    modalTitle() {
      const athleteName = this.roundContext.athlete_name || this.tOr('judging_program.statistics.round_summary', 'Round statistics');
      const stageLabel = this.roundContext.stage_label || this.roundContext.round_name || '';
      return stageLabel ? `${athleteName} · ${stageLabel}` : athleteName;
    },
    modalSubtitle() {
      return this.roundContext.competition_name || '';
    },
  },
  methods: {
    tOr(key, fallback) {
      if (typeof this.$te === 'function' && this.$te(key)) {
        return this.$t(key);
      }

      return fallback;
    },
  },
};
</script>

<style scoped>
.round-stats-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: rgba(15, 23, 42, 0.38);
}

.round-stats-backdrop {
  padding: 1rem;
  z-index: 1200;
}

.round-stats-panel {
  background: #ffffff;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18);
}

.round-stats-modal {
  width: min(1120px, calc(100vw - 2rem));
  max-width: 1120px;
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  border-radius: 18px;
}

.round-stats-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.25rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.round-stats-heading {
  min-width: 0;
}

.round-stats-heading h3 {
  margin: 0;
  font-size: 1.3rem;
  overflow-wrap: anywhere;
}

.round-stats-eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
}

.round-stats-subtitle {
  margin: 0.35rem 0 0;
  color: #6b7280;
}

.round-stats-close {
  width: 2.5rem;
  height: 2.5rem;
  border: 0;
  border-radius: 999px;
  background: #eef2ff;
  color: #1f2937;
  flex-shrink: 0;
}

.round-stats-body {
  overflow-y: auto;
  padding: 1.25rem;
}

@media (max-width: 768px) {
  .round-stats-modal {
    width: calc(100vw - 1rem);
    max-height: calc(100vh - 1rem);
  }

  .round-stats-header,
  .round-stats-body {
    padding-left: 0.9rem;
    padding-right: 0.9rem;
  }

  .round-stats-header {
    align-items: flex-start;
  }
}
</style>